export enum TipoInsumos {
  SUB_DIARIO = 'SUB_DIARIO',
  DRIVER_VENTA = 'DRIVER_VENTA',
  TIPO_CAMBIO = 'TIPO_CAMBIO',
  INSUMO_1 = 'INSUMO_1',
  INSUMO_2 = 'INSUMO_2',
  REGISTRO_ACTIVIDADES = 'REGISTRO_ACTIVIDADES',
  COSTO_HORA = 'COSTO_HORA',
  CC = 'CC',
  PYG = 'PYG',
  VENTAS = 'VENTAS',
  // HORAS_HNOS = 'HORAS_HNOS',
  // HORAS_PERU = 'HORAS_PERU',
  PYG_IFRS_ES = 'PYG_IFRS_ES',
  // HORAS_ESPANA = 'HORAS_ESPANA',
  // HORAS_AJEFILMS = 'HORAS_AJEFILMS',
  SUBDIARIO_ESPANA = 'SUBDIARIO_ESPANA',
  OTROS_GASTOS_HORAS = 'OTROS_GASTOS_HORAS',
  OTROS_GASTOS_FACTURACION = 'OTROS_GASTOS_FACTURACION',
  DISTRIBUCION_MANUAL_GASTOS_BOLSITA = 'DISTRIBUCION_MANUAL_GASTOS_BOLSITA',
  PLANTILLA_DERIVACION_COSTOS = 'PLANTILLA_DERIVACION_COSTOS',

  HORAS_ASESORIAS_PERU_RESUMEN = 'HORAS_ASESORIAS_PERU_RESUMEN',
  HORAS_ASESORIAS_PERU_DETALLADO = 'HORAS_ASESORIAS_PERU_DETALLADO',
  HORAS_ASESORIAS_PERU_RESUMEN_XLSX = 'HORAS_ASESORIAS_PERU_RESUMEN_XLSX',

  HORAS_ASESORIAS_ESPANA_RESUMEN = 'HORAS_ASESORIAS_ESPANA_RESUMEN',
  HORAS_ASESORIAS_ESPANA_DETALLADO = 'HORAS_ASESORIAS_ESPANA_DETALLADO',
  HORAS_ASESORIAS_ESPANA_RESUMEN_XLSX = 'HORAS_ASESORIAS_ESPANA_RESUMEN_XLSX',

  HORAS_ASESORIAS_AJEFILMS_DETALLADO = 'HORAS_ASESORIAS_AJEFILMS_DETALLADO',
  HORAS_ASESORIAS_AJEFILMS_RESUMEN = 'HORAS_ASESORIAS_AJEFILMS_RESUMEN',
  HORAS_ASESORIAS_AJEFILMS_RESUMEN_XLSX = 'HORAS_ASESORIAS_AJEFILMS_RESUMEN_XLSX',

  HORAS_PROYECTOS_AJEFILMS_DETALLADO = 'HORAS_PROYECTOS_AJEFILMS_DETALLADO',
  HORAS_PROYECTOS_AJEFILMS_RESUMEN = 'HORAS_PROYECTOS_AJEFILMS_RESUMEN',
  HORAS_PROYECTOS_AJEFILMS_RESUMEN_XLSX = 'HORAS_PROYECTOS_AJEFILMS_RESUMEN_XLSX',
  LIQUIDACION_AJE_FILMS = 'LIQUIDACION_AJE_FILMS'
}
